/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import {styled} from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import {
  SvgIcon,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';

import LogoComponent from '@modules/public/main/logo/LogoComponent';
import {useNavigate, useParams} from 'react-router-dom';

import {
  closedMixin,
  DrawerHeader,
  openedMixin
} from '../../../common/top-app-bar/TopAppBarStyles';
import {useSnackbar} from 'notistack';
import {CountBadge, ListStyle} from './SubModulesMenuListStyle';
import SmallLogoComponent from '@modules/public/main/small-logo/SmallLogoComponent';
import {
  getDocumentsHierarchyData,
  getPageData,
  getPageSection,
  getSubModuleListData
} from '@shared/services/service-handlers/PrivateService';
import {
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_ROUTE_SUB_MODULE,
  BASE_RECORD_ID,
  PARAMS_KEY,
  BASE_LEGACY_APP,
  BASE_MENU_ITEM,
  BASE_UNIQUE_ID,
  IS_FROM_EPIC,
  IS_FROM_ATHENA,
  BASE_SPECIMEN_NUMBER,
  BASE_SPECIMEN_NUMBER_ID,
  BASE_SPECIMEN_TYPE,
  MODE,
  BASE_DEMOGRAPHIC_ID,
  BASE_PROCEDURE_ID,
  ASSET_INFO_ID,
  BASE_ACCESSION_NUMBER
} from 'src/routes/BaseRoute';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';

import EncryptUtils from 'src/utils/EncryptUtils';
import {useModuleContext} from '@context/ModuleContext';
import AuthUtils from 'src/utils/AuthUtils';
import {useSelectedCheckBoxContext} from '@context/SelectedCheckBoxContext';
import FormConstants from '@shared/constants/FormConstants';
import backIcon from 'src/assets/icons/svg/back_arrow.svg';
import {APP} from 'src/styles/variables';
import IconComponent from '@components/icon/IconComponent';
import {environment} from '@shared/config/environment';
import {useAppContext} from '@context/AppContext';
import NavVertical from 'src/layouts/dashboard/nav-vertical';
import {useResponsive} from 'src/hooks/use-responsive';
import {useSettingsContext} from 'src/minimal-components/settings';
import NavMini from 'src/layouts/dashboard/nav-mini';
import {PulseLoader} from 'react-spinners';
import {useTheme} from '@emotion/react';
import {useRefreshLeftMenu} from '@context/RefreshLeftMenuContext';

interface SubModulesMenuListComponentProps {
  module: string;
  sub_module: string;
  record_id: any;
  navData?: any;
  menuItem: any;
  isFromEpic?: any;
  isFromAthena?: any;
  specimen_number?: any;
  specimen_number_id?: any;
  accessionNumber?: any;
  specimen_type?: any;
  mode?: any;
  legacyApp?: any;
  unique_id?: string;
  handleBannerDetailsAction(data: any): any;
  // eslint-disable-next-line react/boolean-prop-naming
  handleApplyFilterClicked: boolean;
  ParentLegacyValue?: string;
  // eslint-disable-next-line react/boolean-prop-naming
  isOpenNav: boolean;
  onCloseNav: VoidFunction;
}

const SubModuleMenuList = (
  props: SubModulesMenuListComponentProps
): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const theme = useTheme();
  const drawerWidth = 240;
  const [isOpen] = React.useState(true);
  const {isOpenNav, onCloseNav} = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<number | undefined>();
  const navigate = useNavigate();
  const params = useParams();
  const {enqueueSnackbar} = useSnackbar();
  const [data, setData] = React.useState([]);
  const [menuListData, setMenuListData]: any = React.useState({});
  const selectedModuleName = AuthUtils.getSelectedModuleName();
  const {moduleState} = useModuleContext();
  const {moduleData, isBH, isBHReason}: any = moduleState;
  const [moduleName, setModuleName] = React.useState<any>();
  const getLocalStorageData = AuthUtils.getSelectedCheckBoxData();
  const {refreshLeftMenu, setRefreshLeftMenu} = useRefreshLeftMenu();
  const {SelectedCheckBoxState} = useSelectedCheckBoxContext();
  const [filtersData, setFiltersData] = React.useState<any>();
  const isFromEpic = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_EPIC
  );
  const isFromAthena = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_ATHENA
  );

  const [navVariables, setNavVariables] = React.useState<any>({});

  const mode = EncryptUtils.getDecryptedData(location?.search, MODE);
  const risDemographicID = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_DEMOGRAPHIC_ID
  );
  const assetInfoID = EncryptUtils.getDecryptedData(
    location?.search,
    ASSET_INFO_ID
  );
  const procedureID = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_PROCEDURE_ID
  );

  const specimenNumber = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_NUMBER
  );

  const specimenNumberId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_NUMBER_ID
  );
  const accessionNumber = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_ACCESSION_NUMBER
  );
  const specimenType = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_SPECIMEN_TYPE
  );
  const [visitDetails, setVisitDetails] = React.useState(null);
  // const visitDetails = EncryptUtils.getDecryptedData(
  //   location?.search,
  //   BASE_DATA_GRID_ROW
  // );
  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: prop => prop !== 'open'
  })(({theme, open}) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme)
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme)
    })
  }));

  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isMini = settings.themeLayout === 'mini';

  const onChange = (to: string, index?: any) => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: props?.record_id,
      [BASE_LEGACY_APP]: props?.legacyApp,
      [BASE_UNIQUE_ID]: props?.unique_id,
      [IS_FROM_EPIC]: props?.isFromEpic,
      [IS_FROM_ATHENA]: props?.isFromAthena,
      [MODE]: props?.mode,
      [BASE_SPECIMEN_NUMBER]: specimenNumber || props?.specimen_number,
      [BASE_SPECIMEN_NUMBER_ID]: specimenNumberId || props?.specimen_number_id,
      [BASE_ACCESSION_NUMBER]: accessionNumber || props?.accessionNumber,
      [BASE_SPECIMEN_TYPE]: specimenType || props?.specimen_type,
      [BASE_DEMOGRAPHIC_ID]: risDemographicID,
      [BASE_PROCEDURE_ID]: procedureID,
      [ASSET_INFO_ID]: assetInfoID
    });

    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}/${BASE_ROUTE_SUB_MODULE}/${to}?${PARAMS_KEY}=${paramsKey}`;

    if (props?.menuItem) {
      url += `&${BASE_MENU_ITEM}=${props.menuItem}`;
    }
    setNavVariables({
      risDemographicID: risDemographicID ?? '',
      procedureID: procedureID ?? ''
    });
    navigate(url);
  };

  const goBackToModules = (): void => {
    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}`;

    const ignoreMenuItems = ['user-log'];

    const checkCondition =
      props.module == 'pharmacy' && ignoreMenuItems.includes(props?.menuItem);

    if (props?.menuItem && !checkCondition) {
      url += `?${BASE_MENU_ITEM}=${props.menuItem}`;
    }
    navigate(url);
  };

  const initFilterData = () => {
    if (getLocalStorageData) {
      let filtersDataCount = 0;
      const filterData = JSON.parse(getLocalStorageData);
      if (filterData) {
        const checkedRowIds = filterData?.map((row: any) => {
          return row?.ID;
        });
        if (checkedRowIds && checkedRowIds.length)
          filtersDataCount = checkedRowIds.length;
        if (checkedRowIds.length === 0) {
          filtersDataCount = 0;
        }
      }
      setFiltersData(filtersDataCount);
    }
  };

  React.useEffect(() => {
    initFilterData();
  }, [SelectedCheckBoxState]);

  const init = async () => {
    try {
      const res = await getSubModuleListData(
        applicationName,
        props.module,
        props.menuItem
      );
      // to disable submodule item click if there is no patient visit id.
      if (props.module === FormConstants.MODULE.SURGICAL) {
        const parsedVisitDetails = visitDetails ? JSON.parse(visitDetails) : {};
        if (!parsedVisitDetails?.PatientVisitID) {
          res[0].items.map((item: {url: string}, index: string | number) => {
            if (
              item.url === FormConstants.SUB_MODULE.VISITS ||
              item.url === FormConstants.SUB_MODULE.CLINICAL_LOG ||
              item.url === FormConstants.SUB_MODULE.IMPLANT_AND_SUPPLIES ||
              item.url === FormConstants.SUB_MODULE.BILLING ||
              item.url === FormConstants.SUB_MODULE.ACCOUNT
            ) {
              res[0].items[index].disabled = true;
            }
          });
        }
      }
      if (props.module === 'lis') {
        // 1. Generate your filtered/updated list
        const updatedList = res[0]?.items.filter(
          (item: {checkRequired: any}) => {
            if (item.checkRequired) {
              return !!procedureID && props?.module === 'lis';
            }
            return true;
          }
        );

        // 2. Create a NEW object for res[0]
        const updatedRes0: any = [
          {
            ...res[0], // Copy key2 and any other existing keys
            items: updatedList // Overwrite ONLY key1 with the new value
          }
        ];

        // 3. (Optional) If you need to update the parent array
        // const finalRes: [] = [updatedRes0, ...res.slice(1)];
        setData(updatedRes0 || []);
      } else {
        setData(res);
      }

      const focusItem = res[0]?.items.find((item: any) => {
        if(procedureID && props?.module === 'lis') {
          return item.checkRequired 
        }
        return item.isModuleFocus;
      });
      const basePath = res && res[0]?.items[0];
      const itemToNavigate = focusItem || basePath;

      if (itemToNavigate) {
        if (
          location.pathname?.replace(/\/$/, '') ===
          `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props.module}/${BASE_ROUTE_SUB_MODULE}`
        ) {
          onChange(itemToNavigate.url);
        }
      }

      const list = res[0]?.items;

      if (list?.length > 0) {
        list.forEach(async (item: any) => {
          if (item?.show_count) {
            setMenuListData((prevState: any) => ({
              ...prevState,
              [item.url]: {
                count: '',
                loader: true
              }
            }));

            const invoiceNumberLocalStorage =
              localStorage.getItem('invoice_number');

            try {
              const result = await getPageSection(
                applicationName,
                props.module,
                item?.url,
                props.menuItem
              );
              const {sections} = result;

              if (
                sections[0].type === FormConstants.PAGE_SECTION_TYPES.DOCUMENTS
              ) {
                const sql = {
                  document_data_sql: sections[0].document_data_sql,
                  documentFolderSql: sections[0].document_folders_sql,
                  legitDocumentFoldersSql:
                    sections[0].legit_documents_folders_sql,
                  documentsCountSql: sections[0].documents_count_sql
                };
                const dataObj: any = {
                  sql: sql,
                  variables: sections[0].variables,
                  isBH_selected: sections[0]?.sub_sections?.sql_data?.ignoreIsBH
                    ? false
                    : isBH,
                  isBH_reason: isBHReason,
                  application_name: applicationName,
                  accession_number: accessionNumber || props?.accessionNumber,
                  specimen_number_id:specimenNumberId || props?.specimen_number_id,
                };

                if (
                  sections[0]?.is_filter_sql_required &&
                  getLocalStorageData.length > 0
                ) {
                  dataObj.filter_data = getLocalStorageData;
                }

                if (props.ParentLegacyValue) {
                  dataObj.parentLegacyValue = props.ParentLegacyValue;
                }

                if (sections[0]?.filter_schema_clause) {
                  dataObj.filter_schema_clause =
                    sections[0]?.filter_schema_clause;
                }
                if (props.module === 'lis') {
                  dataObj.legacyMRN = props?.record_id;
                }
                dataObj.skip_data = true;
                const encryptRequestData = EncryptUtils.encryptedData(dataObj);
                const response = await getDocumentsHierarchyData(
                  props.module,
                  item?.url,
                  props?.record_id,
                  {tk: encryptRequestData},
                  props?.legacyApp ?? ''
                );

                setMenuListData((prevState: any) => ({
                  ...prevState,
                  [item.url]: {
                    count:
                      response?.count && response?.count.length
                        ? response?.count?.[0]?.count
                        : '',
                    loader: false
                  }
                }));
              } else {
                let pageDataPayload: any = {};
                if (item.url === FormConstants.SCREENS.VITAL) {
                  pageDataPayload = {
                    record_id: props?.record_id,
                    user_id: props?.record_id,
                    sql_data: {
                      count_query_sql:
                        sections[0]?.sub_sections?.sql_data?.count_query_sql,
                      variables: sections[0]?.sub_sections?.sql_data?.variables,
                      sql: sections[0]?.sub_sections?.sql_data?.sql,
                      filter_schema_clause:
                        sections[0]?.sub_sections?.sql_data
                          ?.filter_schema_clause
                    },
                    isBH_selected: sections[0]?.sub_sections?.sql_data
                      ?.ignoreIsBH
                      ? false
                      : isBH,
                    isBH_reason: isBHReason,
                    application_name: applicationName
                  };

                  if (
                    sections[0].sub_sections?.is_filter_sql_required &&
                    getLocalStorageData.length > 0
                  ) {
                    pageDataPayload.filter_data = getLocalStorageData;
                  }
                } else if (
                  item.url === FormConstants.SCREENS.PREGNENCYHISTORY
                ) {
                  pageDataPayload = {
                    record_id: props?.record_id,
                    user_id: props?.record_id,
                    sql_data: {
                      count_query_sql:
                        sections[0]?.sql_data?.count_leftmenu_query_sql,
                      variables: sections[0]?.sql_data?.variables,
                      sql: sections[0]?.sql_data?.sql,
                      filter_schema_clause:
                        sections[0]?.sql_data?.filter_schema_clause
                    },
                    isBH_selected: sections[0]?.sql_data?.ignoreIsBH
                      ? false
                      : isBH,
                    isBH_reason: isBHReason,
                    application_name: applicationName
                  };
                } else {
                  pageDataPayload = {
                    record_id: props?.record_id,
                    user_id: props?.record_id,
                    sql_data: {
                      count_query_sql: sections[0]?.sql_data?.count_query_sql,
                      variables: sections[0]?.sql_data?.variables,
                      sql: sections[0]?.sql_data?.sql,
                      filter_schema_clause:
                        sections[0]?.sql_data?.filter_schema_clause
                    },
                    isBH_selected: sections[0]?.sql_data?.ignoreIsBH
                      ? false
                      : isBH,
                    isBH_reason: isBHReason,
                    application_name: applicationName
                  };
                }

                if (
                  sections[0]?.is_filter_sql_required &&
                  getLocalStorageData.length > 0
                ) {
                  pageDataPayload.filter_data = getLocalStorageData;
                }

                if (props.ParentLegacyValue) {
                  pageDataPayload.parentLegacyApp = props.ParentLegacyValue;
                }

                if (props?.navData?.PatientVisitID) {
                  pageDataPayload.patient_visit_id =
                    props?.navData?.PatientVisitID;
                }

                pageDataPayload.skip_data = true;

                if (invoiceNumberLocalStorage) {
                  pageDataPayload.InvoiceNumber = invoiceNumberLocalStorage;
                }

                const encryptRequestData =
                  EncryptUtils.encryptedData(pageDataPayload);

                const valueData = await getPageData(
                  applicationName,
                  props.module,
                  item.url,
                  {
                    tk: encryptRequestData
                  }
                );

                setMenuListData((prevState: any) => ({
                  ...prevState,
                  [item.url]: {
                    count:
                      valueData?.count && valueData?.count.length
                        ? valueData?.count?.[0]?.count
                        : '',
                    loader: false
                  }
                }));
              }
            } catch (error) {
              setMenuListData((prevState: any) => ({
                ...prevState,
                [item.url]: {
                  count: '',
                  loader: false
                }
              }));
            }
          }
        });
      }

      // if (props?.module && props?.sub_module) {
      //   const selectedModule = res?.list?.find(
      //     (item: {url: string}) => item.url === props.sub_module
      //   );
      //   setActiveTab(selectedModule?.id);
      // } else if (res?.list?.length > 0 && res?.list?.[0]?.url) {
      //   onChange(res?.list[0]?.url, res?.list[0]?.id);
      // }

      props.handleBannerDetailsAction(res[0]);
      setIsLoading(false);
    } catch (error) {
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    setIsLoading(true);

    localStorage.setItem('selectedModule', moduleData);
    setModuleName(localStorage.getItem('selectedModule'));
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    moduleName,
    SelectedCheckBoxState,
    props.ParentLegacyValue,
    visitDetails
  ]);
  React.useEffect(() => {
    if (refreshLeftMenu) {
      init();
      setRefreshLeftMenu(false);
    }
  }, [refreshLeftMenu]);
  const renderCountBadge = (countItem: any) => {
    return (
      <CountBadge
        filterApplied={props?.handleApplyFilterClicked}
        style={
          environment?.styleConfig?.enableCountGrey &&
          !menuListData?.[countItem.url]?.count
            ? {backgroundColor: '#00000000', borderColor: '#00000000'}
            : {}
        }>
        {menuListData?.[countItem.url]?.count > 99
          ? (countItem.url === FormConstants.SUB_MODULE.ENCOUNTERS ||
              countItem.url === FormConstants.SUB_MODULE.ACCOUNTS) &&
            getLocalStorageData &&
            JSON.parse(getLocalStorageData)?.length > 0
            ? `${filtersData}/
            ${99}+
          `
            : `
                      ${99}+
                    `
          : (countItem.url === FormConstants.SUB_MODULE.ENCOUNTERS ||
                countItem.url === FormConstants.SUB_MODULE.ACCOUNTS) &&
              getLocalStorageData &&
              JSON.parse(getLocalStorageData)?.length > 0
            ? `${filtersData}/${menuListData?.[countItem.url]?.count || 0}`
            : menuListData?.[countItem.url]?.count || 0}
      </CountBadge>
    );
  };

  const renderItem = (item: any, index: number): React.ReactElement => {
    return (
      <ListItem key={index} disablePadding sx={{display: 'block'}}>
        <ListItemButton
          sx={{
            minHeight: 30,
            justifyContent: isOpen ? 'initial' : 'center',
            px: 3.2
          }}
          selected={index === activeTab}
          autoFocus={index === activeTab}
          onClick={() => {
            onChange(item.url, index);
          }}
          style={{
            backgroundColor:
              index === activeTab
                ? 'white'
                : environment.styleConfig?.enableCountGrey &&
                    !menuListData?.[item.url]?.count
                  ? '#dddddd'
                  : 'none'
          }}>
          <ListItemText
            primaryTypographyProps={{
              style: {
                color:
                  index === activeTab
                    ? `${APP.PALETTE.SUB_MODULE_COLOR.MAIN}`
                    : `${APP.PALETTE.SUB_MODULE_COLOR.GRAY}`
              },
              fontSize: 14,
              fontWeight: index === activeTab ? 'bold' : 'normal'
            }}
            sx={{opacity: isOpen ? 1 : 0}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '14px'}}>
              {item?.icon ? (
                <IconComponent
                  iconName={item?.icon}
                  sx={{
                    color:
                      index === activeTab
                        ? `${APP.PALETTE.MODULE_LAYOUT_COLOR.MAIN}`
                        : ''
                  }}
                />
              ) : null}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}>
                <div>{item.name[1]}</div>
                <div>
                  {menuListData?.[item.url]?.loader ? (
                    <PulseLoader size={12} color={theme.palette.primary.main} />
                  ) : (
                    item.show_count && renderCountBadge(item)
                  )}
                </div>
              </div>
            </div>
          </ListItemText>
        </ListItemButton>
      </ListItem>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navbarListItems = () => {
    return (
      <ListStyle>
        {data?.map?.((item: any) => renderItem(item, item?.id))}
      </ListStyle>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const renderSelectedModule = (): React.ReactElement => {
    return (
      <ListItem disablePadding sx={{display: 'block', marginTop: '1rem'}}>
        <ListItemButton
          sx={{
            justifyContent: isOpen ? 'initial' : 'center',
            px: 2.2
          }}
          selected
          onClick={() => {
            goBackToModules();
            AuthUtils.clearSelectedCheckBoxData();
            AuthUtils.clearSelectedCheckBoxList();
            AuthUtils.clearAdditionalSelectedCheckBoxList();
            // AuthUtils.clearPatientAccountingSelectedCheckBoxList();
            AuthUtils.clearSelectedAdditionalCheckBoxData();
            // AuthUtils.clearSelectedPatientAccountingCheckBoxData();
          }}
          style={{
            backgroundColor: 'white',
            marginLeft: (isFromEpic || isFromAthena) && mode === 'view' ? 10 : 0
          }}>
          {(isFromEpic || isFromAthena) &&
          mode === FormConstants.STATIC_VALUES.VIEW ? (
            <div />
          ) : (
            <>
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isOpen ? 1 : 'auto',
                  justifyContent: 'center'
                }}>
                <SvgIcon
                  sx={{
                    backgroundImage: `url(${backIcon})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain'
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{
                  style: {
                    color: `${APP.PALETTE.SUB_MODULE_COLOR.MAIN}`
                  },
                  fontSize: 17
                }}
                primary={moduleName || selectedModuleName}
                sx={{opacity: isOpen ? 1 : 0, whiteSpace: 'pre-wrap'}}
              />
            </>
          )}
        </ListItemButton>
      </ListItem>
    );
  };

  const renderNavMini = <NavMini navData={data} isLoading={isLoading} />;

  const renderNavVertical = (
    <NavVertical
      navData={data}
      isOpenNav={isOpenNav}
      onCloseNav={onCloseNav}
      isLoading={isLoading}
      module={props?.module}
      menuItem={props?.menuItem}
      renderCountBadge={renderCountBadge}
      menuListData={menuListData}
      filtersData={filtersData}
      setVisitDetails={setVisitDetails}
    />
  );

  return isMini && lgUp ? renderNavMini : renderNavVertical;
};
export default SubModuleMenuList;

